import { takeUntil } from 'rxjs/operators';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { Subject } from 'rxjs';

@Component({
  imports: [SharedModule, RouterModule],
  selector: 'inspekt-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private router = inject(Router);

  private unsubscribe: Subject<void> = new Subject<void>();
  public isLoggedIn?: boolean = null;

  ngOnInit() {
    this.listenToIsAuthenticatedEvent();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private listenToIsAuthenticatedEvent(): void {
    this.authService.isAuthenticatedSubj.pipe(
      takeUntil(this.unsubscribe))
      .subscribe(isAuthenticated => {
        if (isAuthenticated) {
          this.router.navigateByUrl('/location-picker');
          return;
        }

        this.isLoggedIn = isAuthenticated;
      });
  }
}
